import Firebase from 'firebase'
const firebaseApp = Firebase.initializeApp({
    apiKey: "AIzaSyAX6-DkEsIkpHzQRSXfWOUZ7XkJuhj4hPU",
    authDomain: "reservationapp-7ee8b.firebaseapp.com",
    databaseURL: "https://reservationapp-7ee8b.firebaseio.com",
    storageBucket: "reservationapp-7ee8b.appspot.com",
    messagingSenderId: "319067708096"
});

export const firebaseDB = firebaseApp.database();


// WEBPACK FOOTER //
// ./src/firebase.js